<div class="component-wrapper">
  <div class="d-flex">
    <div class="w-100 c-main">
      <div class="c-main-body">
        <div class="d-flex align-items-center justify-content-between pt-4 pb-3 ng-star-inserted">
          <div class="d-flex align-items-center">
            <p class="f-16 _fw-600">{{ staff_detail?.full_name }} &nbsp;&nbsp;</p>
            <p>Agent Commission Settings</p>
          </div>
        </div>
        <form [formGroup]="commissionForm" action="" class="form">
          <div class="d-flex align-items-center mb-3">
            <p>Apply Commission</p>
            <div class="switch-button ml-5">
              <button
                class="{{ isPercentage == true ? 'button-active-class' : 'button-non-class' }}"
                (click)="isPercentage = !isPercentage"
                [disabled]="isAdmin">
                %
              </button>
              <button
                class="{{ isPercentage == false ? 'button-active-class' : 'button-non-class' }}"
                (click)="isPercentage = !isPercentage"
                [disabled]="isAdmin">
                $
              </button>
            </div>
          </div>
          <div class="d-flex">
            <div class="position-relative" *ngIf="isPercentage == true">
              <p class="mb-2">Commission Rate (%)</p>
              <input
                type="number"
                [min]="0"
                (keydown)="preventMinus($event)"
                (paste)="preventNegativePaste($event)"
                class="site-input my-number-input w-100x"
                formControlName="commission_rate" />
              <i class="cal-icon">%</i>
            </div>
            <div *ngIf="isPercentage == false">
              <p class="mb-2">Commission Amount ($)</p>
              <div class="w-100x">
                <app-price-input
                  [field_value]="commissionForm.controls['commission_amount'].value"
                  (onUpdate)="updatePrice($event, 'commission_amount')">
                </app-price-input>
              </div>
            </div>
            <div class="ml-3 mt-4 d-flex align-items-center">
              <p class="mr-2">Override Default Commission</p>
              <div class="SP-switch">
                <p-inputSwitch formControlName="overrides" (onChange)="overRide()" [disabled]="isAdmin"></p-inputSwitch>
              </div>
            </div>
          </div>
          <ng-container *ngIf="tiered_commission?.length > 0">
            <p class="f-14 _fw-600 mt-3 mb-2">Tiered Commission Rate</p>
            <ng-container *ngFor="let itm of tiered_commission; let ind = index">
              <div class="d-flex mb-2">
                <div class="switch-button mt-22 mr-2">
                  <button
                    class="{{ itm.isPercentage == true ? 'button-active-class' : 'button-non-class' }}"
                    (click)="itm.isPercentage = !itm.isPercentage"
                    [disabled]="isAdmin">
                    %
                  </button>
                  <button
                    class="{{ itm.isPercentage == false ? 'button-active-class' : 'button-non-class' }}"
                    (click)="itm.isPercentage = !itm.isPercentage"
                    [disabled]="isAdmin">
                    $
                  </button>
                </div>
                <div>
                  <p class="mb-2">Upto</p>
                  <input
                    type="number"
                    [min]="0"
                    class="site-input my-number-input w-100x"
                    [(ngModel)]="itm.up_to"
                    [ngModelOptions]="{ standalone: true }"
                    [readonly]="isAdmin" />
                </div>
                <div class="ml-2 position-relative" *ngIf="itm.isPercentage == true">
                  <p class="mb-2">Commission Rate (%)</p>
                  <input
                    type="number"
                    [min]="0"
                    (keydown)="preventMinus($event)"
                    (paste)="preventNegativePaste($event)"
                    class="site-input my-number-input w-100x"
                    [(ngModel)]="itm.commission_rate"
                    [ngModelOptions]="{ standalone: true }"
                    [readonly]="isAdmin" />
                  <i class="cal-icon">%</i>
                </div>
                <div class="ml-2" *ngIf="itm.isPercentage == false">
                  <p class="mb-2">Commission Amount ($)</p>
                  <div class="w-100x">
                    <app-price-input [field_value]="itm.commission_amount" (onUpdate)="updatePrice($event, 'tiered_commission_amount', ind)">
                    </app-price-input>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="specific_commission?.length > 0">
            <p class="f-14 _fw-600 mt-3 mb-2">Apply overrides for specific users, listings, or projects</p>
            <div class="d-flex" *ngFor="let itm of specific_commission; let ind = index">
              <div class="switch-button mt-22 mr-2">
                <button
                  class="{{ itm.isPercentage == true ? 'button-active-class' : 'button-non-class' }}"
                  (click)="itm.isPercentage = !itm.isPercentage"
                  [disabled]="isAdmin">
                  %
                </button>
                <button
                  class="{{ itm.isPercentage == false ? 'button-active-class' : 'button-non-class' }}"
                  (click)="itm.isPercentage = !itm.isPercentage"
                  [disabled]="isAdmin">
                  $
                </button>
              </div>
              <div>
                <p class="mb-2">User</p>
                <ng-select
                  [items]="lmService?.agents"
                  bindLabel="full_name"
                  bindValue="_id"
                  [searchable]="true"
                  [clearable]="true"
                  [(ngModel)]="itm.user_commission"
                  [ngModelOptions]="{ standalone: true }"
                  placeholder="Select"
                  class="w-200"
                  [disabled]="isAdmin">
                  <ng-template ng-option-tmp let-item="item">
                    <div tooltipPosition="top" [pTooltip]="item.full_name">{{ item.full_name }}</div>
                  </ng-template>
                </ng-select>
              </div>
              <div class="mx-2">
                <p class="mb-2">Listing / Project</p>
                <ng-select
                  [items]="commission_category"
                  bindLabel="name"
                  bindValue="value"
                  [searchable]="true"
                  [clearable]="false"
                  [disabled]="isAdmin"
                  class="w-200"
                  [(ngModel)]="itm.commission_category"
                  [ngModelOptions]="{ standalone: true }"
                  placeholder="Select"
                  (change)="showCateBase(itm.commission_category, ind)">
                  <ng-template ng-option-tmp let-item="item">
                    <div tooltipPosition="top" [pTooltip]="item.name">{{ item.name }}</div>
                  </ng-template>
                </ng-select>
              </div>
              <div class="mr-2" *ngIf="itm.commission_category == 'listing'">
                <p class="mb-2">Listing</p>
                <ng-select
                  [items]="lmService?.properties"
                  bindLabel="property_address"
                  bindValue="_id"
                  [searchable]="true"
                  [clearable]="true"
                  [(ngModel)]="itm.listing"
                  [ngModelOptions]="{ standalone: true }"
                  placeholder="Select"
                  class="w-300"
                  [disabled]="isAdmin">
                  <ng-template ng-option-tmp let-item="item">
                    <div tooltipPosition="top" [pTooltip]="item.property_address">{{ item.property_address }}</div>
                  </ng-template>
                </ng-select>
              </div>
              <div class="mr-2" *ngIf="itm.commission_category == 'project'">
                <p class="mb-2">Project</p>
                <ng-select
                  [items]="lmService?.ProjectList"
                  bindLabel="Project_Name"
                  bindValue="_id"
                  [searchable]="true"
                  [clearable]="true"
                  [(ngModel)]="itm.project"
                  [ngModelOptions]="{ standalone: true }"
                  placeholder="Select"
                  class="w-300"
                  [disabled]="isAdmin">
                  <ng-template ng-option-tmp let-item="item">
                    <div tooltipPosition="top" [pTooltip]="item.Project_Name">{{ item.Project_Name }}</div>
                  </ng-template>
                </ng-select>
              </div>
              <div class="position-relative" *ngIf="itm.isPercentage == true">
                <p class="mb-2">Commission Rate (%)</p>
                <input
                  type="number"
                  [min]="0"
                  (keydown)="preventMinus($event)"
                  (paste)="preventNegativePaste($event)"
                  class="site-input my-number-input w-100x"
                  [(ngModel)]="itm.commission_rate"
                  [ngModelOptions]="{ standalone: true }"
                  [readonly]="isAdmin" />
                <i class="cal-icon">%</i>
              </div>
              <div *ngIf="itm.isPercentage == false">
                <p class="mb-2">Commission Amount ($)</p>
                <div class="w-100x">
                  <app-price-input [field_value]="itm.commission_amount" (onUpdate)="updatePrice($event, 'specific_commission_amount', ind)">
                  </app-price-input>
                </div>
              </div>
            </div>
          </ng-container>
          <div
            class="form-group text-right"
            *ngxPermissionsOnly="['setting.commission_setup.manage', 'setting.commission_setup.create', 'setting.commission_setup.update']">
            <button class="_outline-btn" (click)="saveCommission()">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
